import React, { useState, useEffect, useRef } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import DeferredTextField from './controls/DeferredTextField';
import { isEmpty } from 'lodash';
import Controls from "./controls/Controls";
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import dayjs from 'dayjs';
import _ from 'lodash';
import { useAuthStore } from '../store/authStore';
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import * as CommonFunctions from '../services/CommonFunctions';

export default function FormDialog({ open, handleClose, onChange, handleFormSubmit, setFormData, formData, supervisors, tariffs, accountingApps }) {
  const { id, name, surname, companyName, gmailPassword, isActive, isContract, forum, cooperationHistoryDTOs, accountantAppDTO, accountantSupervisorDTOs, accountantTariffDTOs, phones, emails,
    maxNumberOfClients, declaredMaxNumberOfClients, isMoreClientsAccepted, isMoreClientsWanted, clientNumberComment, nip, insuranceUpTo, fileMetadataDTOS } = formData
  const [errors, setErrors] = useState({});
  // Derived values - computed from props to avoid per-keystroke re-renders
  const active = cooperationHistoryDTOs && cooperationHistoryDTOs[0]?.cooperationEndDate === null;
  const cooperationEndDate = cooperationHistoryDTOs && cooperationHistoryDTOs[0]?.cooperationEndDate;
  const phoneNumber = phones?.find(phone => phone.tphoneTypeId === 21)?.number || '';
  const aliasSevenPM = emails?.find(email => email.temailTypeId === 1)?.emailAddress || '';
  const gmail = emails?.find(email => email.temailTypeId === 11)?.emailAddress || '';
  const delegatedAccount = emails?.find(email => email.temailTypeId === 41)?.emailAddress || '';
  const tariffList = accountantTariffDTOs?.length > 0 ? accountantTariffDTOs : [];
  const supervisorList = accountantSupervisorDTOs?.length > 0 ? accountantSupervisorDTOs : [];
  const [isNew, setIsNew] = useState(false);
  const [showGmailPassword, setShowGmailPassword] = useState(false);
  const { roles: roles } = useAuthStore();

  const isRemoveButtonVisible = roles?.includes('ADMIN') || roles?.includes('ADMIN_SUPERVISOR') || roles?.includes('MANAGER');
  const isNumberOfClientsEditable = roles?.includes('SUPERVISOR') || roles?.includes('SUPERVISOR_ACCOUNTANT') || roles?.includes('ADMIN') || roles?.includes('ADMIN_SUPERVISOR') || roles?.includes('MANAGER');
  const isViewOnly = roles?.includes('CHIEF_ACCOUNTANT');
  const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const numberRegex = /^\d+$/;
  const phoneNumberRegex = /^[0-9]{9,14}$/;
  const nipRegex = /^[0-9]{10}$/;
  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
  }));
  const [insuranceFiles, setInsuranceFiles] = useState([]);
  const [filesToDelete, setFilesToDelete] = useState([]);
  const [additionalInfoFiles, setAdditionalInfoFiles] = useState([]);
  const [files, setFiles] = useState([]);
  const [openPolicyDialog, setOpenPolicyDialog] = useState(false);
  const [policyValidFrom, setPolicyValidFrom] = useState('');
  const [policyValidTo, setPolicyValidTo] = useState('');
  const [policyFile, setPolicyFile] = useState(null);
  const [policyErrors, setPolicyErrors] = useState({});
  const [openEditPolicyDialog, setOpenEditPolicyDialog] = useState(false);
  const [editPolicyIndex, setEditPolicyIndex] = useState(null);
  const [editValidFrom, setEditValidFrom] = useState('');
  const [editValidTo, setEditValidTo] = useState('');
  const [isSubmittingEdit, setIsSubmittingEdit] = useState(false);
  const token = useAuthStore().token;

  useEffect(() => {
    if (open) {
      // Mapowanie plików z backendu i dodanie pola isLocal
      const initialFiles = fileMetadataDTOS.map(({ filename, ...rest }) => ({
        ...rest,
        name: filename, // Przemianowanie pola
        isLocal: false, // Dodanie pola isLocal
      }));

      // Znalezienie pliku typu 31 (kopie polisy)
      const insuranceFilesList = initialFiles.filter((file) => file.fileType === 31);

      // Filtracja plików typu 41 (dodatkowe pliki)
      const additionalFiles = initialFiles.filter((file) => file.fileType === 41);

      // Ustawienie stanów
      setInsuranceFiles(insuranceFilesList || []);
      setAdditionalInfoFiles(additionalFiles || []);
      setFiles([]); // Reset plików lokalnych
      setFilesToDelete([]); // Reset plików do usunięcia
      setIsSubmitting(false);
    }
  }, [open, fileMetadataDTOS]);



  const handleEditPolicyClick = (file, index) => {
    setEditPolicyIndex(index);
    setEditValidFrom(file.validFrom ? (Array.isArray(file.validFrom) ? dayjs(new Date(file.validFrom[0], file.validFrom[1] - 1, file.validFrom[2])).format('YYYY-MM-DD') : dayjs(file.validFrom).format('YYYY-MM-DD')) : '');
    setEditValidTo(file.validTo ? (Array.isArray(file.validTo) ? dayjs(new Date(file.validTo[0], file.validTo[1] - 1, file.validTo[2])).format('YYYY-MM-DD') : dayjs(file.validTo).format('YYYY-MM-DD')) : '');
    setOpenEditPolicyDialog(true);
  };

  const handleEditPolicySave = async () => {
    if (!editValidFrom || !editValidTo) {
      alert("Obie daty są wymagane.");
      return;
    }
    const fileToEdit = insuranceFiles[editPolicyIndex];
    setIsSubmittingEdit(true);

    if (!fileToEdit.isLocal) {
      const success = await CommonFunctions.updateFileDates(fileToEdit.id, editValidFrom, editValidTo, token);
      if (!success) {
        setIsSubmittingEdit(false);
        return;
      }
    }

    setInsuranceFiles(prevFiles => {
      const newFiles = [...prevFiles];
      newFiles[editPolicyIndex] = { ...fileToEdit, validFrom: editValidFrom, validTo: editValidTo };
      return newFiles;
    });

    setIsSubmittingEdit(false);
    setOpenEditPolicyDialog(false);
  };

  const EndButton = styled(Button)(({ theme }) => ({
    marginTop: 28,
    width: "100%"
  }));

  const ConditionButton = styled(Button)(({ theme }) => ({
    marginTop: 15,
  }));


  /*Walidacja Start*/

  const validateFormOnSubmit = () => {
    let formIsValid = true;
    let errors = {};

    if (isEmpty(name)) {
      errors.name = 'Pole imię jest wymagane';
      formIsValid = false;
    }

    if (isEmpty(surname)) {
      errors.surname = 'Pole nazwisko jest wymagane';
      formIsValid = false;
    }

    if (isEmpty(companyName)) {
      errors.companyName = 'Pole nazwa firmy zleceniodawcy jest wymagane';
      formIsValid = false;
    }
    // if (nip === null || nip.length === 0) {
    //   errors.nip = 'Pole jest wymagane';
    //   formIsValid = false;
    // }
    // if (!nipRegex.test(nip)) {
    //   errors.nip = 'Wprowadź poprawny numer NIP';
    //   formIsValid = false;
    // }
    if (!emailRegex.test(gmail)) {
      errors.gmail = 'Wprowadź poprawny adres email';
      formIsValid = false;
    }

    if (isEmpty(gmail)) {
      errors.gmail = 'Pole gmail jest wymagane';
      formIsValid = false;
    }

    if (isEmpty(gmailPassword)) {
      errors.gmailPassword = 'Pole alias 7pm jest wymagane';
      formIsValid = false;
    }
    if (!emailRegex.test(aliasSevenPM)) {
      errors.aliasSevenPM = 'Wprowadź poprawny adres email';
      formIsValid = false;
    }
    if (isEmpty(aliasSevenPM)) {
      errors.aliasSevenPM = 'Pole jest wymagane';
      formIsValid = false;
    }
    if (!phoneNumberRegex.test(phoneNumber)) {
      errors.phoneNumber = 'Wprowadź poprawny numer telefonu (tylko cyfry).';
      formIsValid = false;
    }
    if (isEmpty(phoneNumber)) {
      errors.phoneNumber = 'Pole numer telefonu jest wymagane';
      formIsValid = false;
    }
    if (isNumberOfClientsEditable) {
      if (!numberRegex.test(maxNumberOfClients)) {
        errors.maxNumberOfClients = 'Wprowadź poprawną liczbę';
        formIsValid = false;
      }
      if (maxNumberOfClients === null || maxNumberOfClients === undefined || maxNumberOfClients === '') {
        errors.maxNumberOfClients = 'Pole jest wymagane';
        formIsValid = false;
      }
    }
    if (isEmpty(delegatedAccount)) {
      errors.delegatedAccount = 'Pole konto oddelegowane jest wymagane';
      formIsValid = false;
    }
    if (isContract === '' || isContract === null || isContract === 0) {
      errors.isContract = 'Pole umowa jest wymagane';
      formIsValid = false;
    }
    if (forum === '' || forum === null || forum === 0) {
      errors.forum = 'Pole forum jest wymagane';
      formIsValid = false;
    }

    // Walidacja cooperationHistoryDTOs
    if (!errors.cooperationHistoryDTOs) {
      errors.cooperationHistoryDTOs = [{}];
    }
    if (cooperationHistoryDTOs && cooperationHistoryDTOs?.[0]?.cooperationStartDate === null ||
      cooperationHistoryDTOs?.[0]?.cooperationStartDate === '') {
      errors.cooperationHistoryDTOs[0].cooperationStartDate = 'Pole jest wymagane';
      formIsValid = false;
    }

    // Walidacja accountantTariffDTOs
    if (!errors.accountantTariffDTOs) {
      errors.accountantTariffDTOs = [{}];
    }
    if (accountantTariffDTOs?.[0]?.startDate === '' || accountantTariffDTOs?.[0]?.startDate === null || accountantTariffDTOs?.[0]?.startDate === undefined) {
      errors.accountantTariffDTOs[0].startDate = 'Pole jest wymagane';
      formIsValid = false;
    }
    else if (accountantTariffDTOs?.[0]?.startDate) {
      const startDate = new Date(accountantTariffDTOs[0].startDate);
      const endDateOfPreviousElement = accountantTariffDTOs[1] ? new Date(accountantTariffDTOs[1].endDate) : null;
      if (endDateOfPreviousElement && (startDate <= endDateOfPreviousElement)) {
        errors.accountantTariffDTOs[0].startDate = 'Data początkowa musi być późniejsza niż data końcowa poprzedniego wiersza.';
        formIsValid = false;
      }
    }

    if (accountantTariffDTOs?.[0]?.ttariffId === '' || accountantSupervisorDTOs?.[0]?.ttariffId === null) {
      errors.accountantTariffDTOs[0].ttariffId = 'Pole jest wymagane';
      formIsValid = false;
    }

    if (accountantTariffDTOs?.[0]?.startDate && accountantTariffDTOs?.[0]?.endDate) {
      const startDate = new Date(accountantTariffDTOs[0].startDate);
      const endDate = new Date(accountantTariffDTOs[0].endDate);

      if (endDate < startDate) {
        errors.accountantTariffDTOs[0].endDate = 'Data końcowa nie może być wcześniejsza niż data początkowa';
        formIsValid = false;
      }
    }

    //Walidacja accountingApp

    if (accountantAppDTO.accountingAppId === '' || accountantAppDTO.accountingAppId === null) {
      errors.accountantAppDTO = { accountingAppId: 'Pole jest wymagane' };
      formIsValid = false;
    }
    if (!errors.accountantDTOs) {
      errors.accountantDTOs = [{}];
    }


    // Walidacja accountantSupervisorDTOs
    if (!errors.accountantSupervisorDTOs) {
      errors.accountantSupervisorDTOs = [{}];
    }
    if (accountantSupervisorDTOs?.[0]?.startDate === '' || accountantSupervisorDTOs?.[0]?.startDate === null) {
      errors.accountantSupervisorDTOs[0].startDate = 'Data rozpoczęcia jest wymagana';
      formIsValid = false;
    }

    if (accountantSupervisorDTOs?.[0]?.endDate === 'null') {
      accountantSupervisorDTOs[0].endDate = null;
    }
    // Walidacja dat startowych i końcowych
    if (accountantSupervisorDTOs[1] && accountantSupervisorDTOs[1].endDate !== null) {
      const startDate = dayjs(accountantSupervisorDTOs[0].startDate);
      const endDate = dayjs(accountantSupervisorDTOs[1].endDate);
      if (endDate.isAfter(startDate)) {
        errors.accountantSupervisorDTOs[0].startDate = 'Data początkowa musi być starsza niż data końcowa poprzedniego wiersza';
        formIsValid = false;
      }
    }
    // Walidacja accountantSupervisorDTOs[0].contactIdB
    if (accountantSupervisorDTOs?.[0]?.contactIdB === '' || accountantSupervisorDTOs?.[0]?.contactIdB === null) {
      errors.accountantSupervisorDTOs[0].contactIdB = 'Pole superwizor jest wymagane';
      formIsValid = false;
    }

    // Walidacja accountantSupervisorDTOs[0].endDate
    if (accountantSupervisorDTOs?.[0]?.endDate !== null && accountantSupervisorDTOs?.[0]?.endDate !== 'null') {
      const startDate = dayjs(accountantSupervisorDTOs?.[0]?.startDate);
      const endDate = dayjs(accountantSupervisorDTOs?.[0]?.endDate);
      if (endDate.isBefore(startDate)) {
        errors.accountantSupervisorDTOs[0].endDate = 'Data końcowa nie może być wcześniejsza niż data początkowa';
        formIsValid = false;
      }
    }

    setErrors(errors);
    return formIsValid;
  };

  const validateField = (name, value) => {
    let isValid = true;
    const newErrors = _.cloneDeep(errors);

    if (name !== "accountantSupervisorDTOs[0].endDate" && name !== "nip" && name !== "accountantTariffDTOs[0].endDate" && name != "declaredMaxNumberOfClients" && name !== "isMoreClientsAccepted" && name !== "isMoreClientsWanted" && name !== "clientNumberComment" && (value === null || value.length === 0)) {
      _.set(newErrors, name, "Pole nie może być puste.");
    } else {

      if (name === "accountantSupervisorDTOs[0].startDate") {
        const startDate = dayjs(value);
        const endDate = accountantSupervisorDTOs[0] ? dayjs(accountantSupervisorDTOs[0].endDate) : null;
        const endDateOfPreviousElement = accountantSupervisorDTOs[1] ? dayjs(accountantSupervisorDTOs[1].endDate) : null;

        if (endDate && endDate.isBefore(startDate)) {
          _.set(newErrors, name, "Data początkowa nie może być późniejsza niż data końcowa");
          isValid = false;
        } else if (endDateOfPreviousElement !== null && (endDateOfPreviousElement.isAfter(startDate) || endDateOfPreviousElement.isSame(startDate, 'day'))) {
          _.set(newErrors, name, "Data początkowa musi być późniejsza niż data końcowa poprzedniego wiersza.");
          isValid = false;
        } else {
          _.unset(newErrors, name);
          _.unset(newErrors, 'accountantSupervisorDTOs[0].endDate');
        }
      }
      else if (name === "accountantSupervisorDTOs[0].endDate") {
        const startDate = accountantSupervisorDTOs[0] ? dayjs(accountantSupervisorDTOs[0].startDate) : null;
        const endDate = dayjs(value);

        if (startDate && endDate.isBefore(startDate)) {
          _.set(newErrors, name, "Data końcowa nie może być wcześniejsza niż data początkowa.");
          isValid = false;
        } else {
          _.unset(newErrors, name);
          _.unset(newErrors, 'accountantSupervisorDTOs[0].startDate');
        }
      }

      else if (name === "accountantTariffDTOs[0].startDate") {
        const startDate = dayjs(value);
        const endDate = accountantTariffDTOs[0] ? dayjs(accountantTariffDTOs[0].endDate) : null;
        const endDateOfPreviousElement = accountantTariffDTOs[1] ? dayjs(accountantTariffDTOs[1].endDate) : null;

        if (endDate && endDate.isBefore(startDate)) {
          _.set(newErrors, name, "Data początkowa nie może być późniejsza niż data końcowa");
          isValid = false;
        } else if (endDateOfPreviousElement !== null && (endDateOfPreviousElement.isAfter(startDate) || endDateOfPreviousElement.isSame(startDate, 'month'))) {
          _.set(newErrors, name, "Data początkowa musi być późniejsza niż data końcowa poprzedniego wiersza.");
          isValid = false;
        } else {
          _.unset(newErrors, name);
          _.unset(newErrors, 'accountantTariffDTOs[0].endDate');
        }
      }
      else if (name === "accountantTariffDTOs[0].endDate") {
        const startDate = accountantTariffDTOs[0] ? dayjs(accountantTariffDTOs[0].startDate) : null;
        const endDate = dayjs(value);

        if (startDate && endDate.isBefore(startDate)) {
          _.set(newErrors, name, "Data końcowa nie może być wcześniejsza niż data początkowa.");
          isValid = false;
        } else {
          _.unset(newErrors, name);
          _.unset(newErrors, 'accountantTariffDTOs[0].startDate');
        }
      }
      else if (name === "gmail" || name === "aliasSevenPM") {
        if (!emailRegex.test(value)) {
          _.set(newErrors, name, "Wprowadź poprawny adres email.");
        } else {
          _.unset(newErrors, name); // Usunięcie błędu
        }
      }
      else if (name === "phoneNumber") {
        if (!phoneNumberRegex.test(value)) {
          _.set(newErrors, name, "Wprowadź poprawny numer telefonu (tylko cyfry).");
        } else {
          _.unset(newErrors, name); // Usunięcie błędu
        }
      }
      else if (name === "nip") {
        if (!nipRegex.test(value)) {
          _.set(newErrors, name, "Wprowadź poprawny numer NIP");
        } else {
          _.unset(newErrors, name); // Usunięcie błędu
        }
      }
      else if (name === "maxNumberOfClients") {
        if (isNumberOfClientsEditable && !numberRegex.test(value)) {
          _.set(newErrors, name, "Wprowadź poprawny numer");
        } else {
          _.unset(newErrors, name); // Usunięcie błędu
        }
      }
      else {
        _.unset(newErrors, name); // Usunięcie błędu dla innych pól
      }
    }
    setErrors(newErrors);
    return isValid;
  };
  /*WALIDACJA KONIEC*/


  const handleToggleGmailPasswordVisibility = () => {
    setShowGmailPassword(!showGmailPassword);
  };

  const handleAddNewTariff = () => {
    setFormData(prevFormData => {
      const tariffsLocal = prevFormData.accountantTariffDTOs || [];
      const lastTariff = tariffsLocal[0];

      // Sprawdzenie, czy istnieje ostatni element i czy ma uzupełnione wymagane pola
      if (lastTariff && (!lastTariff.startDate || !lastTariff.endDate || !lastTariff.ttariffId)) {
        // Wyświetlenie komunikatu o błędzie (możesz użyć alertu lub innego mechanizmu do wyświetlania komunikatów)
        alert("Proszę uzupełnić prawidłowo wszystkie pola przed dodaniem nowego elementu.");
        return { ...prevFormData };
      }

      // Sprawdzenie, czy data końcowa nie jest wcześniejsza niż data początkowa
      if (lastTariff && new Date(lastTariff.endDate) < new Date(lastTariff.startDate)) {
        alert("Proszę uzupełnić prawidłowo wszystkie pola przed dodaniem nowego elementu.");
        return { ...prevFormData };
      }

      // Dodanie nowego elementu na początek listy, przesuwając poprzedni element w dół
      tariffsLocal.unshift({
        startDate: '',
        endDate: '',
        ttariffId: '' // Dodano domyślną wartość, jeśli to konieczne
      });

      return {
        ...prevFormData,
        accountantTariffDTOs: tariffsLocal
      };
    });
  };

  const handleRemoveLastTariffListElement = () => {
    setFormData((prevFormData) => {
      const updatedElements = [...(prevFormData.accountantTariffDTOs || [])];
      updatedElements.shift();
      return { ...prevFormData, accountantTariffDTOs: updatedElements };
    });
  };

  const handleFilesChange = (event, fileType, fileAssignmentId, setFilesStateFunc) => {
    const maxFileSize = 2 * 1024 * 1024; // 2 MB in bytes

    const newFiles = Array.from(event.target.files).map(file => {
      if (file.size > maxFileSize) {
        alert("Plik jest za duży. Maksymalny rozmiar to 2 MB.");
        return null; // Ignore this file
      }
      return {
        isLocal: true,
        file,
        fileType: fileType,
        fileAssignmentId: fileAssignmentId,
        name: file.name,
      };
    }).filter(file => file !== null); // Remove null entries

    setFilesStateFunc(prevFiles => {
      // Filtrujemy nowe pliki, aby uniknąć dodania duplikatów
      const uniqueNewFiles = newFiles.filter(newFile =>
        !prevFiles.some(
          existingFile =>
            existingFile.name === newFile.name
        )
      );

      if (uniqueNewFiles.length < newFiles.length) {
        alert("Ten plik został już załadowany.");
      }

      return [...prevFiles, ...uniqueNewFiles];
    });
  };

  const handleDeleteFile = async (fileId, fileTypeId) => {
    let isLocalFile = false;
    let fileList = fileTypeId === 31 ? insuranceFiles : additionalInfoFiles;

    isLocalFile = fileList.some(file => file.isLocal && file.file.name === fileId);

    if (fileTypeId === 31) {
      setInsuranceFiles(prev => isLocalFile ? prev.filter(f => !(f.isLocal && f.file.name === fileId)) : prev.filter(f => f.id !== fileId));
    } else if (fileTypeId === 41) {
      setAdditionalInfoFiles(prev => isLocalFile ? prev.filter(f => !(f.isLocal && f.file.name === fileId)) : prev.filter(f => f.id !== fileId));
    }

    if (!isLocalFile) {
      // Dodanie do listy plików do usunięcia tylko jeśli plik istnieje na backendzie
      setFilesToDelete(prev => [...prev, { id: fileId }]);
    }
  };

  const handlePolicyDialogSave = () => {
    let errs = {};
    if (!policyValidFrom) errs.validFrom = "Wymagane";
    if (!policyValidTo) errs.validTo = "Wymagane";
    if (!policyFile) errs.file = "Wymagane";

    if (Object.keys(errs).length > 0) {
      setPolicyErrors(errs);
      return;
    }

    const maxFileSize = 2 * 1024 * 1024;
    if (policyFile.size > maxFileSize) {
      alert("Plik jest za duży. Maksymalny rozmiar to 2 MB.");
      return;
    }

    const newFileObj = {
      isLocal: true,
      file: policyFile,
      fileType: 31,
      fileAssignmentId: 11,
      name: policyFile.name,
      validFrom: policyValidFrom,
      validTo: policyValidTo
    };

    setInsuranceFiles(prevFiles => {
      const isDuplicate = prevFiles.some(f => (f.file ? f.file.name : f.name) === policyFile.name);
      if (isDuplicate) {
        alert("Ten plik został już załadowany.");
        return prevFiles;
      }
      return [...prevFiles, newFileObj];
    });

    setOpenPolicyDialog(false);
    setPolicyValidFrom('');
    setPolicyValidTo('');
    setPolicyFile(null);
    setPolicyErrors({});
  };

  const handleDownloadFile = async (fileId, fileType) => {
    CommonFunctions.downloadFile(fileId, fileType, name + " " + surname, null, null, token);
  };

  const handleAddNewSupervisor = () => {
    setFormData(prevFormData => {
      const supervisorsLocal = prevFormData.accountantSupervisorDTOs || [];
      const lasteElement = supervisorsLocal[0];

      // Sprawdzenie, czy istnieje ostatni element i czy ma uzupełnione wymagane pola
      if (lasteElement && (!lasteElement.startDate || !lasteElement.endDate || !lasteElement.contactIdB)) {
        // Wyświetlenie komunikatu o błędzie (możesz użyć alertu lub innego mechanizmu do wyświetlania komunikatów)
        alert("Proszę uzupełnić prawidłowo wszystkie pola przed dodaniem nowego elementu.");
        return { ...prevFormData };
      }

      // Sprawdzenie, czy data końcowa nie jest wcześniejsza niż data początkowa
      if (lasteElement && new Date(lasteElement.endDate) < new Date(lasteElement.startDate)) {
        alert("Proszę uzupełnić prawidłowo wszystkie pola przed dodaniem nowego elementu.");
        return { ...prevFormData };
      }

      // Dodanie nowego elementu na początek listy, przesuwając poprzedni element w dół
      supervisorsLocal.unshift({
        id: null,
        relationshipTypeId: 1,
        startDate: '',
        endDate: '',
        contactIdB: '' // Dodano domyślną wartość, jeśli to konieczne
      });

      return {
        ...prevFormData,
        accountantSupervisorDTOs: supervisorsLocal
      };
    });
  };

  const handleRemoveLastSupervisorListElement = () => {
    setFormData((prevFormData) => {
      const updatedElements = [...(prevFormData.accountantSupervisorDTOs || [])];
      updatedElements.shift();
      return { ...prevFormData, accountantSupervisorDTOs: updatedElements };
    });
  };
  const handlePhoneChange = (e) => {
    const { name, value } = e.target;
    validateField(name, value);
    const newPhoneNumber = value;

    setFormData(prevFormData => {
      let updatedPhones = [...(prevFormData.phones || [])];
      if (updatedPhones.length === 1 && updatedPhones[0].id === null && updatedPhones[0].tphoneTypeId === null) {
        updatedPhones = [{ id: null, number: newPhoneNumber, tphoneTypeId: 21 }];
      } else {
        const existingPhone = updatedPhones.find(phone => phone.tphoneTypeId === 21);
        if (existingPhone) {
          updatedPhones = updatedPhones.map(phone =>
            phone.tphoneTypeId === 21 ? { ...phone, number: newPhoneNumber } : phone
          );
        } else {
          updatedPhones.push({ id: null, number: newPhoneNumber, tphoneTypeId: 21 });
        }
      }
      return { ...prevFormData, phones: updatedPhones };
    });
  };

  const handleEmailChange = (e, emailTypeId) => {
    const { name, value } = e.target;
    validateField(name, value);
    const newEmailAddress = value;

    setFormData(prevFormData => {
      let updatedEmails = [...(prevFormData.emails || [])];
      if (updatedEmails.length === 1 && updatedEmails[0].id === null && updatedEmails[0].temailTypeId === null) {
        updatedEmails = [{ id: null, emailAddress: newEmailAddress, temailTypeId: emailTypeId }];
      } else {
        const existingEmail = updatedEmails.find(email => email.temailTypeId === emailTypeId);
        if (existingEmail) {
          updatedEmails = updatedEmails.map(email =>
            email.temailTypeId === emailTypeId ? { ...email, emailAddress: newEmailAddress } : email
          );
        } else {
          updatedEmails.push({ id: null, emailAddress: newEmailAddress, temailTypeId: emailTypeId });
        }
      }
      return { ...prevFormData, emails: updatedEmails };
    });
  };

  const isSubmittingRef = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    if (isSubmittingRef.current) return; // Jeśli trwa przetwarzanie, przerwij

    isSubmittingRef.current = true; // Blokujemy dalsze kliknięcia
    setIsSubmitting(true); // Aktualizacja stanu React

    const isValid = validateFormOnSubmit();

    if (isValid) {
      try {
        CommonFunctions.normalizeAccountantDates(formData);
        handleFormSubmit(files, filesToDelete, [...additionalInfoFiles, ...insuranceFiles]);
      } finally {
        setTimeout(() => {
          isSubmittingRef.current = false; // Odblokowanie po 2 sek
          setIsSubmitting(false);
        }, 2000); // 2-sekundowe opóźnienie
      }
    } else {
      alert("Uzupełnij prawidłowo wymagane pola");
      isSubmittingRef.current = false; // Odblokowanie od razu, jeśli formularz nie jest poprawny
      setIsSubmitting(false);
    }
  };


  const handleDateChange = (name, value) => {
    validateField(name, value)
    // Sprawdź, czy wartość jest datą w formacie YYYY-MM
    const datePattern = /^\d{4}-\d{2}$/;
    if (datePattern.test(value)) {
      // Dodaj '-01' do daty, aby uzyskać format YYYY-MM-DD
      value = `${value}-01`;
    }
    const datePatternYearOnly = /^\d{4}$/;
    if (datePatternYearOnly.test(value)) {
      // Dodaj '-01-01' do daty, aby uzyskać format YYYY-MM-DD
      value = `${value}-01-01`;
    }
    setFormData(prevState => {
      const newState = { ...prevState };
      // Ustawienie wartości dla innych pól
      _.set(newState, name, value);
      return newState;
    });
  };

  const handleCooperationState = () => {
    const today = new Date().toISOString().split('T')[0];
    const newCooperationEndDate = cooperationEndDate === null ? today : null;
    const newActiveState = newCooperationEndDate === null;

    setFormData(prevState => {
      const newState = { ...prevState };
      _.set(newState, 'isActive', newActiveState);
      _.set(newState, 'cooperationHistoryDTOs[0].cooperationEndDate', newCooperationEndDate);
      return newState;
    });
  };

  const localOnChange = (e) => {
    const { name, value } = e.target;
    validateField(name, value);

    // Aktualizacja stanu formularza
    setFormData(prevState => {
      const newState = { ...prevState };
      if (name === 'accountantSupervisorDTOs[0].contactIdB' && accountantSupervisorDTOs[0].id === null) {
        _.set(accountantSupervisorDTOs, '[0].relationshipTypeId', 1);
      }
      _.set(newState, name, value);
      return newState;
    });
  };

  const localHandleClose = () => {
    handleClose();
    setIsNew(false);
    setErrors({});
  };

  const getClientsAcceptedAnswer = () => ([
    { key: true, value: 'TAK, przydzielamy nowych klientów' },
    { key: false, value: 'NIE PRZYDZIELAMY' }
  ]);

  const getClientsWantedAnswer = () => ([
    { key: true, value: 'CHCE WIĘCEJ KLIENTÓW' },
    { key: false, value: 'NIE CHCE WIĘCEJ KLIENTÓW' }
  ]);

  const getStatus = () => ([
    { key: true, value: 'Aktywna' },
    { key: false, value: 'Zakończona' }
  ])

  const getTrueFalse = () => ([
    { key: true, value: 'Tak' },
    { key: false, value: 'Nie' }
  ])

  return (
    <div>
      <Dialog
        open={open}
        onClose={localHandleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // maxWidth="lg"
        fullScreen
      >
        <DialogTitle id="alert-dialog-title">{id === 0 ? "Dodaj księgową" : "Karta księgowej"}</DialogTitle>
        <Divider />
        <DialogContent>
          <form>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
              <Grid item xs={12}>
                <Div>{"Dane podstawowe"}</Div>
              </Grid>
              <Grid item xs={6}>
                <DeferredTextField
                  name="name"
                  value={name}
                  onChange={localOnChange}
                  placeholder="Wprowadź imię"
                  label="Imię"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  error={!!errors.name}
                  helperText={errors.name}
                  InputProps={{
                    style: { fontWeight: "bold" },
                    readOnly: isViewOnly
                  }}
                />
                <DeferredTextField
                  name="surname"
                  value={surname}
                  onChange={localOnChange}
                  placeholder="Wprowadź nazwisko"
                  label="Nazwisko"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  error={!!errors.surname}
                  helperText={errors.surname}
                  InputProps={{
                    style: { fontWeight: "bold" },
                    readOnly: isViewOnly
                  }}
                />
                <DeferredTextField
                  name="companyName"
                  value={companyName}
                  onChange={localOnChange}
                  placeholder="Wprowadź nazwę Firmy Zleceniobiorcy"
                  label="Nazwa firmy zleceniobiorcy"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  error={!!errors.companyName}
                  helperText={errors.companyName}
                  InputProps={{
                    readOnly: isViewOnly
                  }}
                />
                <DeferredTextField
                  name="nip"
                  value={nip}
                  onChange={localOnChange}
                  placeholder="Wprowadź NIP"
                  label="NIP"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  error={!!errors.nip}
                  helperText={errors.nip}
                  InputProps={{
                    style: { fontWeight: "bold" },
                    readOnly: isViewOnly
                  }} />

                <DeferredTextField
                  name="phoneNumber"
                  value={phoneNumber}
                  onChange={handlePhoneChange}
                  placeholder="Wprowadź telefon"
                  label="Telefon"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  type="tel"
                  error={!!errors.phoneNumber}
                  helperText={errors.phoneNumber}
                  InputProps={{
                    readOnly: isViewOnly
                  }}
                />
                <Box sx={{ m: '60px' }} />
              </Grid>
              <Grid item xs={6}>
                <DeferredTextField
                  name="gmail"
                  value={gmail}
                  onChange={(e) => handleEmailChange(e, 11)}
                  placeholder="Wprowadź adres gmail"
                  label="Gmail"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  error={!!errors.gmail}
                  helperText={errors.gmail}
                  InputProps={{
                    readOnly: isViewOnly
                  }}
                />
                <DeferredTextField
                  name="gmailPassword"
                  value={gmailPassword}
                  onChange={localOnChange}
                  placeholder="Wprowadź hasło gmail"
                  label="Hasło gmail"
                  type={showGmailPassword ? 'text' : 'password'}
                  variant="outlined"
                  margin="dense"
                  autocomplete="off"
                  fullWidth
                  error={!!errors.gmailPassword}
                  helperText={errors.gmailPassword}
                  InputProps={{
                    autocomplete: "off",
                    readOnly: isViewOnly,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleToggleGmailPasswordVisibility}
                          aria-label={showGmailPassword ? 'Ukryj hasło' : 'Pokaż hasło'}
                          edge="end"
                        >
                          {showGmailPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <DeferredTextField
                  name="aliasSevenPM"
                  value={aliasSevenPM}
                  onChange={(e) => handleEmailChange(e, 1)}
                  placeholder="Wprowadź alias 7pm"
                  label="Alias 7pm"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  error={!!errors.aliasSevenPM}
                  helperText={errors.aliasSevenPM}
                  InputProps={{
                    style: { color: "#9c27b0" },
                    readOnly: isViewOnly
                  }}
                />
                <DeferredTextField
                  name="delegatedAccount"
                  value={delegatedAccount}
                  onChange={(e) => handleEmailChange(e, 41)}
                  placeholder="Wprowadź konto oddelegowane"
                  label="Konto oddelegowane"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  error={!!errors.delegatedAccount}
                  helperText={errors.delegatedAccount}
                  InputProps={{
                    readOnly: isViewOnly
                  }}
                />
              </Grid>
            </Grid>
            <Divider />
            <Box sx={{ m: '15px' }} />

            {/* WSPÓŁPRACA I SUPERWIZOR */}
            <Grid container rowSpacing={1} spacing={{ xs: 2, md: 4 }} columns={{ xs: 2, sm: 6, md: 12 }}>
              <Grid item xs={12}>
                <Div>{"Status i historia współpracy"}</Div>
              </Grid>
              <Grid item xs={6}>
                <Controls.Select
                  name="isContract"
                  label="Umowa"
                  value={isContract}
                  isColor={true}
                  onChange={localOnChange}
                  options={getTrueFalse()}
                  variant="outlined"
                  margin="dense"
                  error={errors.isContract}
                  readOnly={isViewOnly}
                />
                <Controls.Select
                  name="forum"
                  label="Forum"
                  value={forum}
                  isColor={true}
                  onChange={localOnChange}
                  options={getTrueFalse()}
                  variant="outlined"
                  margin="dense"
                  error={errors.forum}
                  readOnly={isViewOnly}
                />
                <Controls.MyDatePicker
                  name="cooperationHistoryDTOs[0].cooperationStartDate"
                  label="Rozpoczęcie współpracy"
                  value={cooperationHistoryDTOs?.[0]?.cooperationStartDate}
                  onChange={newValue => handleDateChange('cooperationHistoryDTOs[0].cooperationStartDate', newValue)}
                  error={!!(errors.cooperationHistoryDTOs && errors.cooperationHistoryDTOs[0].cooperationStartDate)}
                  helperText={errors.cooperationHistoryDTOs && errors.cooperationHistoryDTOs[0].cooperationStartDate}
                  disabled={false}
                  format={"YYYY-MM"}
                  views={["year", "month"]}
                  readOnly={isViewOnly}
                />
                {id !== null && (
                  <>
                    <Controls.Select
                      name="isActive"
                      label="Status współpracy"
                      readOnly={true}
                      isColor={true}
                      isBoolean={true}
                      value={active}
                      onChange={localOnChange}
                      options={getStatus()}
                      variant="outlined"
                      margin="dense"
                      error={errors.active}
                    />
                    <Grid
                      container
                      rowSpacing={{ xs: 1, sm: 1, md: 2 }}
                      spacing={{ xs: 1, sm: 2, md: 2 }}
                      columns={{ xs: 2, sm: 6, md: 12 }}
                    >
                      <Grid item xs={6}>
                        <Controls.MyDatePicker
                          key={cooperationEndDate ? "date-filled" : "date-empty"}
                          name="cooperationHistoryDTOs[0].cooperationEndDate"
                          value={cooperationEndDate}
                          disabled={isActive}
                          placeholder="Data zakończenia współpracy"
                          onChange={(newValue) =>
                            handleDateChange("cooperationHistoryDTOs[0].cooperationEndDate", newValue)
                          }
                          label="Data zakończenia współpracy"
                          format={"YYYY-MM"}
                          views={["year", "month"]}
                          fullWidth
                          readOnly={isViewOnly}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        {cooperationEndDate === null ? (
                          <EndButton
                            color="secondary"
                            size="medium"
                            onClick={handleCooperationState}
                            variant="contained"
                            disabled={isViewOnly}
                          >
                            Zakończ współpracę
                          </EndButton>
                        ) : (
                          <EndButton
                            color="primary"
                            size="medium"
                            onClick={handleCooperationState}
                            variant="contained"
                            disabled={isViewOnly}
                          >
                            Wznów współpracę
                          </EndButton>
                        )}
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
              <Grid item xs={6}>
                {accountantSupervisorDTOs && accountantSupervisorDTOs.length > 0 && (
                  <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                    <Grid item xs={6} >
                      {accountantSupervisorDTOs.slice(0, 4).map((element, index) => (
                        <Controls.Select
                          key={index}
                          name={`accountantSupervisorDTOs[${index}].contactIdB`}
                          value={element.contactIdB}
                          options={supervisors}
                          style={{ color: '#9c27b0' }}
                          disabled={index !== 0}
                          label={index === 0 ? 'Superwizor' : 'Poprzedni Superwizor'}
                          error={!!(errors.accountantSupervisorDTOs && errors.accountantSupervisorDTOs[index] && errors.accountantSupervisorDTOs[index].contactIdB)}
                          onChange={localOnChange}
                          fullWidth
                          readOnly={isViewOnly}
                        />
                      ))}
                    </Grid>
                    <Grid item xs={3} >
                      {accountantSupervisorDTOs.slice(0, 4).map((element, index) => (
                        <Controls.MyDatePicker
                          name={`accountantSupervisorDTOs[${index}].startDate`}
                          label="Od"
                          disabled={index !== 0}
                          value={element.startDate}
                          error={!!(errors.accountantSupervisorDTOs && errors.accountantSupervisorDTOs[index] && errors.accountantSupervisorDTOs[index].startDate)}
                          helperText={errors.accountantSupervisorDTOs && errors.accountantSupervisorDTOs[index] ? errors.accountantSupervisorDTOs[index].startDate : undefined}
                          onChange={newValue => handleDateChange(`accountantSupervisorDTOs[${index}].startDate`, newValue)}
                          style={{ width: '50px' }}
                          format={"YYYY-MM"}
                          views={["year", "month"]}
                          readOnly={isViewOnly}
                        />
                      ))}
                    </Grid>
                    <Grid item xs={3} >
                      {accountantSupervisorDTOs.slice(0, 4).map((element, index) => (
                        <Controls.MyDatePicker
                          name={`accountantSupervisorDTOs[${index}].endDate`}
                          label="Do"
                          disabled={index !== 0}
                          value={element.endDate}
                          error={!!(errors.accountantSupervisorDTOs && errors.accountantSupervisorDTOs[index] && errors.accountantSupervisorDTOs[index].endDate)}
                          helperText={errors.accountantSupervisorDTOs && errors.accountantSupervisorDTOs[index] ? errors.accountantSupervisorDTOs[index].endDate : undefined}
                          onChange={newValue => handleDateChange(`accountantSupervisorDTOs[${index}].endDate`, newValue)}
                          format={"YYYY-MM"}
                          views={["year", "month"]}
                          readOnly={isViewOnly}
                        />
                      ))}
                    </Grid>
                  </Grid>
                )}
                <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid item xs={6} >
                    {accountantSupervisorDTOs && accountantSupervisorDTOs.length > 1 && (isRemoveButtonVisible || accountantSupervisorDTOs[0].id === null) && (
                      <ConditionButton variant="contained" onClick={handleRemoveLastSupervisorListElement} disabled={isViewOnly}>
                        Usuń ostatni element
                      </ConditionButton>
                    )}
                  </Grid>
                  <Grid item xs={6} >
                    <ConditionButton style={{ float: 'right' }} variant="contained" color="secondary" onClick={handleAddNewSupervisor} disabled={isViewOnly}>
                      Dodaj nowy wiersz
                    </ConditionButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box sx={{ m: '50px' }} />
            <Divider />
            <Box sx={{ m: '15px' }} />
            <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
              <Grid item xs={12}>
                <Div>{"Przydzielanie Klientów"}</Div>
              </Grid>
              <Box sx={{ m: '10px' }} />
            </Grid>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
              <Grid item xs={3}>
                <Controls.Select
                  name="isMoreClientsAccepted"
                  label="Czy 7PM chce przydzielić klientów?"
                  value={isMoreClientsAccepted}
                  isColor={true}
                  onChange={localOnChange}
                  options={getClientsAcceptedAnswer()}
                  error={errors.isMoreClientsAccepted && errors.isMoreClientsAccepted}
                  variant="outlined"
                  margin="dense"
                  readOnly={!isNumberOfClientsEditable}
                />
              </Grid>
              <Grid item xs={3}>
                <DeferredTextField
                  name="maxNumberOfClients"
                  value={maxNumberOfClients}
                  placeholder="Wprowadź maksymalną liczbę klientów"
                  label="Maksymalna liczba klientów"
                  variant="outlined"
                  margin="dense"
                  onChange={(e) => localOnChange(e)}
                  fullWidth
                  error={!!errors.maxNumberOfClients}
                  helperText={errors.maxNumberOfClients}
                  inputProps={{
                    readOnly: !isNumberOfClientsEditable
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <Controls.Select
                  name="isMoreClientsWanted"
                  label="Czy księgowa/y chce przyjąć klientów?"
                  value={isMoreClientsWanted}
                  isColor={true}
                  onChange={localOnChange}
                  options={getClientsWantedAnswer()}
                  error={errors.isMoreClientsWanted && errors.accountantAppDTO.isMoreClientsWanted}
                  variant="outlined"
                  margin="dense"
                  readOnly={isViewOnly}
                />
              </Grid>
              <Grid item xs={3}>
                <DeferredTextField
                  name="declaredMaxNumberOfClients"
                  value={declaredMaxNumberOfClients}
                  placeholder="Wprowadź deklarowane maksimum"
                  label="Deklarowane maksimum"
                  variant="outlined"
                  margin="dense"
                  onChange={(e) => localOnChange(e)}
                  fullWidth
                  error={!!errors.declaredMaxNumberOfClients}
                  helperText={errors.declaredMaxNumberOfClients}
                  inputProps={{
                    readOnly: isViewOnly
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <DeferredTextField
                  name="clientNumberComment"
                  value={clientNumberComment}
                  onChange={localOnChange}
                  placeholder="Wpisz tekst"
                  label="Komentarze / Uwagi"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  multiline
                  rows={2}
                  error={!!errors.clientNumberComment}
                  helperText={errors.clientNumberComment}
                  inputProps={{
                    maxLength: 200,
                    readOnly: !isNumberOfClientsEditable
                  }}
                />
              </Grid>
            </Grid>
            <Box sx={{ m: '50px' }} />
            <Divider />
            <Box sx={{ m: '15px' }} />
            {/* PRACUJE NA */}
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
              <Grid item xs={12}>
                <Div>{"Program księgowy"}</Div>
              </Grid>
              <Grid item xs={6}>
                <Controls.Select
                  name="accountantAppDTO.accountingAppId"
                  label="Pracuje na:"
                  value={accountantAppDTO?.accountingAppId}
                  isColor={true}
                  onChange={localOnChange}
                  options={accountingApps}
                  error={errors.accountantAppDTO && errors.accountantAppDTO.accountingAppId}
                  variant="outlined"
                  margin="dense"
                  readOnly={isViewOnly}
                />
              </Grid>
            </Grid>
            <Box sx={{ m: '36px' }} />
            <Divider />
            <Box sx={{ m: '15px' }} />
            {/* POLISA OC*/}
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
              <Grid item xs={12}>
                <Div>{"Polisa OC"}</Div>
              </Grid>
              <Grid item xs={6}>
                <Controls.MyDatePicker
                  name={"insuranceUpTo"}
                  label="Ważność Polisy OC"
                  value={insuranceUpTo}
                  onChange={newValue => handleDateChange("insuranceUpTo", newValue)}
                  error={!!errors.insuranceUpTo}
                  helperText={errors.insuranceUpTo}
                  format={"YYYY-MM-DD"}
                  readOnly={isViewOnly}
                />
              </Grid>

              <Grid item xs={3}>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => setOpenPolicyDialog(true)}
                  fullWidth
                  disabled={isViewOnly}
                  sx={{ mt: 3 }}
                >
                  Wgraj kopie polisy
                </Button>
              </Grid>
              <Grid item xs={6}></Grid>
              <Grid item xs={12}>
                {insuranceFiles && insuranceFiles.length > 0 && (
                  <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell><strong>Polisa</strong></TableCell>
                          <TableCell><strong>Ważna Od</strong></TableCell>
                          <TableCell><strong>Ważna Do</strong></TableCell>
                          <TableCell align="center"><strong>Akcje</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {insuranceFiles
                          .slice()
                          .sort((a, b) => {
                            const getVTo = (f) => {
                              if (f.validTo) return Array.isArray(f.validTo) ? dayjs(new Date(f.validTo[0], f.validTo[1] - 1, f.validTo[2])) : dayjs(f.validTo);
                              if (f.createdOn) return Array.isArray(f.createdOn) ? dayjs(new Date(f.createdOn[0], f.createdOn[1] - 1, f.createdOn[2])).add(1, 'year') : dayjs(f.createdOn).add(1, 'year');
                              return dayjs(0);
                            };
                            return getVTo(b).diff(getVTo(a)); // Descending
                          })
                          .map((file, index) => {
                            const parseD = (d) => Array.isArray(d) ? dayjs(new Date(d[0], d[1] - 1, d[2])) : dayjs(d);

                            let validFromStr = "Brak danych";
                            let validToStr = "Brak danych";

                            if (file.validFrom) {
                              validFromStr = parseD(file.validFrom).format('DD.MM.YYYY');
                            }

                            if (file.validTo) {
                              validToStr = parseD(file.validTo).format('DD.MM.YYYY');
                            }

                            return (
                              <TableRow key={index}>
                                <TableCell>{file.name}</TableCell>
                                <TableCell>{validFromStr}</TableCell>
                                <TableCell>{validToStr}</TableCell>
                                <TableCell align="center">
                                  <IconButton color="primary" onClick={() => handleEditPolicyClick(file, index)} size="small" disabled={isViewOnly}>
                                    <EditIcon />
                                  </IconButton>
                                  {!file.isLocal && (
                                    <IconButton color="primary" onClick={() => handleDownloadFile(file.id, file.fileType)} size="small">
                                      <DownloadIcon />
                                    </IconButton>
                                  )}
                                  <IconButton color="error" onClick={() => handleDeleteFile(file.isLocal ? file.file.name : file.id, 31)} size="small" disabled={isViewOnly}>
                                    <DeleteIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Grid>
            </Grid>
            <Box sx={{ m: '36px' }} />
            <Divider />
            <Box sx={{ m: '15px' }} />

            {/* Informacje Dodatkowe */}
            {isNumberOfClientsEditable && (
              <>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                  <Grid item xs={12}>
                    <Div>{"Informacje dodatkowe"}</Div>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      variant="contained"
                      color="success"
                      component="label"
                      fullWidth
                      disabled={isViewOnly}
                      sx={{ mt: 3 }}
                    >
                      Wgraj plik
                      <input type="file" hidden multiple onChange={(e) => handleFilesChange(e, 41, 11, setAdditionalInfoFiles)} />
                    </Button>
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={12}>
                    {additionalInfoFiles && additionalInfoFiles.length > 0 && (
                      additionalInfoFiles.map((file, index) => (
                        <Typography key={index} mt={0} display="flex" alignItems="center">
                          <strong>Wgrano plik: </strong>&nbsp;{file.name}
                          {!file.isLocal && (
                            <>
                              <IconButton
                                color="primary"
                                onClick={() => handleDownloadFile(file.id, file.fileType)}
                                size="small"
                                sx={{ ml: 1 }}
                              >
                                <DownloadIcon />
                              </IconButton>
                            </>
                          )}
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteFile(file.isLocal ? file.file.name : file.id, file.fileType)}
                            size="small"
                            disabled={isViewOnly}
                            sx={{ ml: 1 }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Typography>
                      ))
                    )}
                  </Grid>
                </Grid>
                <Box sx={{ m: '36px' }} />
                <Divider />
                <Box sx={{ m: '15px' }} />
              </>
            )}
            <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
              <Grid item xs={12}>
                <Div>{"Warunki współpracy"}</Div>
              </Grid>
              <Box sx={{ m: '10px' }} />
            </Grid>
            <Box sx={{ m: '15px' }} />
            {tariffList && tariffList.length > 0 && (
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                <Grid item xs={6} >
                  {tariffList.slice(0, 4).map((element, index) => (
                    <Controls.Select
                      name={`accountantTariffDTOs[${index}].ttariffId`}
                      value={element.ttariffId}
                      options={tariffs}
                      style={{ color: '#9c27b0' }}
                      disabled={index !== 0}
                      label="Warunki współpracy"
                      error={!!(errors.accountantTariffDTOs && errors.accountantTariffDTOs[index] && errors.accountantTariffDTOs[index].ttariffId)}
                      onChange={localOnChange}
                      fullWidth
                      readOnly={isViewOnly}
                    />
                  ))}
                </Grid>
                <Grid item xs={3} >
                  {tariffList.slice(0, 4).map((element, index) => (
                    <Controls.MyDatePicker
                      name={`accountantTariffDTOs[${index}].startDate`}
                      label="Od"
                      disabled={index !== 0}
                      value={element.startDate}
                      onChange={newValue => handleDateChange(`accountantTariffDTOs[${index}].startDate`, newValue)}
                      error={!!(errors.accountantTariffDTOs && errors.accountantTariffDTOs[index] && errors.accountantTariffDTOs[index].startDate)}
                      helperText={errors.accountantTariffDTOs && errors.accountantTariffDTOs[index] ? errors.accountantTariffDTOs[index].startDate : undefined}
                      format={"YYYY-MM"}
                      views={["year", "month"]}
                      readOnly={isViewOnly}
                    />
                  ))}
                </Grid>
                <Grid item xs={3} >
                  {tariffList.slice(0, 4).map((element, index) => (
                    <Controls.MyDatePicker
                      name={`accountantTariffDTOs[${index}].endDate`}
                      label="Do"
                      disabled={index !== 0}
                      value={element.endDate}
                      onChange={newValue => handleDateChange(`accountantTariffDTOs[${index}].endDate`, newValue)}
                      error={!!(errors.accountantTariffDTOs && errors.accountantTariffDTOs[index] && errors.accountantTariffDTOs[index].endDate)}
                      helperText={errors.accountantTariffDTOs && errors.accountantTariffDTOs[index] ? errors.accountantTariffDTOs[index].endDate : undefined}
                      format={"YYYY-MM"}
                      views={["year", "month"]}
                      readOnly={isViewOnly}
                    />
                  ))}
                </Grid>
              </Grid>
            )}
            <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={6} >
                {tariffList?.length > 1 && isRemoveButtonVisible && (
                  <ConditionButton variant="contained" onClick={handleRemoveLastTariffListElement} disabled={isViewOnly}>
                    Usuń ostatni element
                  </ConditionButton>
                )}
              </Grid>
              <Grid item xs={6} >
                <ConditionButton style={{ float: 'right' }} variant="contained" color="secondary" onClick={handleAddNewTariff} disabled={isViewOnly}>
                  Dodaj nowe warunki
                </ConditionButton>
              </Grid>
            </Grid>
            <Box sx={{ m: '100px' }} />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={localHandleClose} color="secondary" variant="outlined">
            Anuluj
          </Button>
          <Button color="primary" onClick={handleSubmit} variant="contained" disabled={isViewOnly || isSubmitting}>
            {id === null ? "Dodaj" : "Aktualizuj"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openPolicyDialog} onClose={() => setOpenPolicyDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Wgraj polisę OC</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Controls.MyDatePicker
              name="policyValidFrom"
              label="Okres ubezpieczenia od"
              value={policyValidFrom}
              onChange={val => setPolicyValidFrom(val)}
              error={!!policyErrors.validFrom}
              helperText={policyErrors.validFrom}
              format="YYYY-MM-DD"
            />
            <Controls.MyDatePicker
              name="policyValidTo"
              label="Okres ubezpieczenia do"
              value={policyValidTo}
              onChange={val => setPolicyValidTo(val)}
              error={!!policyErrors.validTo}
              helperText={policyErrors.validTo}
              format="YYYY-MM-DD"
            />
            <Button
              variant="outlined"
              component="label"
              color={policyErrors.file ? "error" : "primary"}
            >
              {policyFile ? policyFile.name : "Wybierz plik z dysku"}
              <input type="file" hidden onChange={(e) => setPolicyFile(e.target.files[0])} />
            </Button>
            {policyErrors.file && <Typography color="error" variant="caption">{policyErrors.file}</Typography>}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPolicyDialog(false)}>Anuluj</Button>
          <Button onClick={handlePolicyDialogSave} color="primary" variant="contained">Dodaj</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditPolicyDialog} onClose={() => setOpenEditPolicyDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Edytuj okres polisy OC</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Controls.MyDatePicker
              name="editValidFrom"
              label="Okres ubezpieczenia od"
              value={editValidFrom}
              onChange={val => setEditValidFrom(val)}
              format="YYYY-MM-DD"
            />
            <Controls.MyDatePicker
              name="editValidTo"
              label="Okres ubezpieczenia do"
              value={editValidTo}
              onChange={val => setEditValidTo(val)}
              format="YYYY-MM-DD"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditPolicyDialog(false)}>Anuluj</Button>
          <Button onClick={handleEditPolicySave} color="primary" variant="contained" disabled={isSubmittingEdit}>Zapisz</Button>
        </DialogActions>
      </Dialog>
    </div >
  );
}